import GraphContentModel, * as graphContentModels from './contentmodel';

export const ContentModels = graphContentModels;
export const ContentModel = GraphContentModel;

import './style.css';
import 'c3/c3.min.css';

export const description = "Generate a dynamic graph based on database variables.";
export const instructions = ``;



// WEBPACK FOOTER //
// ./app_modules/graph-activity/src/index.js